import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const GrayEcommerceLanding = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width={65}
    height={65}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <circle cx={32.5} cy={32.5} r={32.5} fill="#E5EBF0" fillOpacity={0.17} />
    <g transform="translate(16.5,18)">
      <path
        d="M31.7333 0H2.26667C1.00741 0 0 1.00471 0 2.2606V29.7394C0 30.9953 1.00741 32 2.26667 32H31.7333C32.9926 32 34 30.9953 34 29.7394V2.2606C34 1.00471 32.9926 0 31.7333 0ZM32.7407 29.7394C32.7407 30.292 32.2874 30.7441 31.7333 30.7441H2.26667C1.71259 30.7441 1.25926 30.292 1.25926 29.7394V6.63108C1.30963 6.63108 1.41037 6.68132 1.46074 6.68132H32.7407V29.7394ZM32.7407 5.42543H1.46074C1.41037 5.42543 1.30963 5.42543 1.25926 5.47567V2.2606C1.25926 1.70801 1.71259 1.25589 2.26667 1.25589H31.7333C32.2874 1.25589 32.7407 1.70801 32.7407 2.2606V5.42543Z"
        fill="#0E233E"
      />
      <path
        d="M4.53321 4.42067C5.06177 4.42067 5.49025 3.99333 5.49025 3.46619C5.49025 2.93905 5.06177 2.51172 4.53321 2.51172C4.00465 2.51172 3.57617 2.93905 3.57617 3.46619C3.57617 3.99333 4.00465 4.42067 4.53321 4.42067Z"
        fill="#0E233E"
      />
      <path
        d="M7.30372 4.42067C7.83227 4.42067 8.26075 3.99333 8.26075 3.46619C8.26075 2.93905 7.83227 2.51172 7.30372 2.51172C6.77516 2.51172 6.34668 2.93905 6.34668 3.46619C6.34668 3.99333 6.77516 4.42067 7.30372 4.42067Z"
        fill="#0E233E"
      />
      <path
        d="M10.074 4.42067C10.6025 4.42067 11.031 3.99333 11.031 3.46619C11.031 2.93905 10.6025 2.51172 10.074 2.51172C9.54542 2.51172 9.11694 2.93905 9.11694 3.46619C9.11694 3.99333 9.54542 4.42067 10.074 4.42067Z"
        fill="#0E233E"
      />
      <path
        d="M29.8194 2.81323H21.7097C21.3572 2.81323 21.0549 3.11465 21.0549 3.46629C21.0549 3.81794 21.3572 4.11935 21.7097 4.11935H29.8194C30.172 4.11935 30.4742 3.81794 30.4742 3.46629C30.4742 3.11465 30.172 2.81323 29.8194 2.81323Z"
        fill="#0E233E"
      />
      <path
        d="M6.34671 10.9012H10.4267L13.0963 20.4961H10.5778C9.57041 20.4961 8.71412 21.3501 8.71412 22.3548C8.71412 23.3595 9.57041 24.2136 10.5778 24.2136H13.9526C13.046 24.515 12.3912 25.369 12.3912 26.3737C12.3912 27.6296 13.4489 28.6845 14.7082 28.6845C15.9675 28.6845 17.0252 27.6296 17.0252 26.3737C17.0252 25.369 16.3704 24.515 15.4637 24.2136H20.4C19.4934 24.515 18.8386 25.369 18.8386 26.3737C18.8386 27.6296 19.8963 28.6845 21.1556 28.6845C22.4149 28.6845 23.4726 27.6296 23.4726 26.3737C23.4726 25.369 22.8178 24.515 21.9112 24.2136H25.5378C25.8904 24.2136 26.1926 23.9121 26.1926 23.5605C26.1926 23.2088 25.8904 22.9074 25.5378 22.9074H10.5778C10.2252 22.9074 9.97338 22.6563 9.97338 22.3046C9.97338 21.953 10.2252 21.7018 10.5778 21.7018H13.9023H23.2712C23.523 21.7018 23.7749 21.5511 23.8756 21.2497L26.5956 12.9608C26.6963 12.6092 26.646 12.2575 26.4445 12.0063C26.243 11.7049 25.8904 11.5542 25.5378 11.5542H14.7082C14.3556 11.5542 14.0534 11.8556 14.0534 12.2073C14.0534 12.5589 14.3556 12.8603 14.7082 12.8603H25.286L22.7675 20.4961H14.3556L11.5852 10.449C11.4341 9.99691 11.0312 9.64526 10.5275 9.64526H6.34671C5.99412 9.64526 5.69189 9.94668 5.69189 10.2983C5.69189 10.65 5.99412 10.9012 6.34671 10.9012ZM21.206 25.3187C21.8104 25.3187 22.2637 25.7709 22.2637 26.3737C22.2637 26.9765 21.8104 27.4286 21.206 27.4286C20.6015 27.4286 20.1482 26.9765 20.1482 26.3737C20.1482 25.7709 20.6015 25.3187 21.206 25.3187ZM14.7082 25.3187C15.3126 25.3187 15.766 25.7709 15.766 26.3737C15.766 26.9765 15.3126 27.4286 14.7082 27.4286C14.1037 27.4286 13.6504 26.9765 13.6504 26.3737C13.6504 25.7709 14.1541 25.3187 14.7082 25.3187Z"
        fill="#0E233E"
      />
    </g>
    <defs>
      <clipPath id="clip0_11410_678">
        <rect width="34" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(GrayEcommerceLanding);
export default ForwardRef;
